var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4863 9.20208L16.9647 4.29767C16.5758 7.51953 13.8303 9.243 13.8303 9.243C14.8504 5.55827 14.0079 1.57931 12.7175 0L3.47916 10.219L3.49083 10.2227C1.62416 12.3151 0.5 15.0112 0.5 17.9546C0.5 24.607 6.24067 30 13.3222 30C20.8523 30 25.5 24.607 25.5 17.9546C25.5 14.507 23.3135 10.9978 21.4863 9.20208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3249 15.3317L6.81253 13.9298C5.46884 13.7245 4.22166 14.5393 4.22166 15.6219V21.7296C4.22166 23.5293 5.75492 25.103 7.95499 25.561L15.1381 26.953C16.8041 27.2999 18.4342 26.3057 18.4342 24.9424V19.4809C18.5995 17.586 17.0461 15.7472 14.3249 15.3317ZM9.08357 22.1425C9.0801 22.2696 8.98295 22.3524 8.86624 22.3273L7.12922 21.9522C7.01251 21.9271 6.92072 21.8034 6.92419 21.6762L7.00336 18.7092C7.00683 18.5821 7.10398 18.4993 7.22069 18.5245L8.95772 18.8996C9.07442 18.9247 9.16621 19.0484 9.16274 19.1755L9.08357 22.1425ZM13.6048 23.0636C13.6014 23.1908 13.5042 23.2735 13.3875 23.2484L11.6505 22.8733C11.5338 22.8482 11.442 22.7245 11.4454 22.5974L11.5246 19.6303C11.5281 19.5032 11.6252 19.4204 11.7419 19.4456L13.479 19.8207C13.5957 19.8458 13.6875 19.9695 13.684 20.0966L13.6048 23.0636Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasi);
export default __webpack_public_path__ + "static/media/Casi.6c934eb9fe71a0b8c6a4d6a01e78bf26.svg";
export { ForwardRef as ReactComponent };